export const APIS = {
    '': 'Geen API',
    AFAS: 'AFAS',
    Loket: 'Loket',
    ADP: 'ADP',
    Exact: 'Exact',
    'SD Worx': 'SD Worx',
};

export const DATE_TEXT = {
    days: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
    months: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december',
    ],
    monthsShort: [
        'jan',
        'feb',
        'mrt',
        'apr',
        'mei',
        'jun',
        'jul',
        'aug',
        'sep',
        'okt',
        'nov',
        'dec',
    ],
    today: 'Vandaag',
    now: 'Nu',
    am: 'AM',
    pm: 'PM',
};

export const ROLES = {
    'super-admin': 'Systeembeheerder',
    reseller: 'Reseller',
    admin: 'Klantbeheerder',
    user: 'Standaardgebruiker',
};

export const SALARY_PACKAGE = {
    ADP: 'ADP',
    'Afas Profit': 'Afas Profit',
    Applyloon: 'Applyloon',
    'Baan IV Payroll': 'Baan IV Payroll',
    BCS: 'BCS',
    Casio: 'Casio',
    'Casio (Raet)': 'Casio (Raet)',
    CBBS: 'CBBS',
    'Centic (Paymaster)': 'Centic (Paymaster)',
    'Centric (PIMS)': 'Centric (PIMS)',
    'Cobra CTB': 'Cobra CTB',
    'CSN Pilon': 'CSN Pilon',
    'E Business Suite, Peoplesoft, JD Edwards (Oracle)':
        'E Business Suite, Peoplesoft, JD Edwards (Oracle)',
    Easyflex: 'Easyflex',
    Easylon: 'Easylon',
    'Ecare zorgtoepassingen': 'Ecare zorgtoepassingen',
    Ecodet: 'Ecodet',
    'Elsevier Loon Programma': 'Elsevier Loon Programma',
    Emis: 'Emis',
    'e-UUR': 'e-UUR',
    Exact: 'Exact',
    'Flex Management Systeem (FMS)': 'Flex Management Systeem (FMS)',
    FlexGate: 'FlexGate',
    'Flex-Go': 'Flex-Go',
    Flexservice: 'Flexservice',
    Freepack: 'Freepack',
    Hatasal: 'Hatasal',
    'HR Plus': 'HR Plus',
    'HR Web': 'HR Web',
    HR2day: 'HR2day',
    'Humanwave Basis Online personeelsadministratie':
        'Humanwave Basis Online personeelsadministratie',
    Kluwer: 'Kluwer',
    Logica: 'Logica',
    Logipoort: 'Logipoort',
    Logisal: 'Logisal',
    'Loket.nl': 'Loket.nl',
    'Loon (RoosRoos)': 'Loon (RoosRoos)',
    Loonbasis: 'Loonbasis',
    'Loonmutatie Tool': 'Loonmutatie Tool',
    Loonpro: 'Loonpro',
    Mercash: 'Mercash',
    Merces: 'Merces',
    Microloon: 'Microloon',
    'MySolution FLEX': 'MySolution FLEX',
    'Mysolution PRO': 'Mysolution PRO',
    'NMBRS ®': 'NMBRS ®',
    'Nocore (Intersoft)': 'Nocore (Intersoft)',
    'Paycheck Web proforma salarisberekening':
        'Paycheck Web proforma salarisberekening',
    'PayCheck5, proforma salarisberekening':
        'PayCheck5, proforma salarisberekening',
    'Payroll (Yoursoft)': 'Payroll (Yoursoft)',
    'People Inc.': 'People Inc.',
    Polaris: 'Polaris',
    'PROBIS Loon- en salarisadministratie':
        'PROBIS Loon- en salarisadministratie',
    'Raet (youforce)': 'Raet (youforce)',
    SalarFusion: 'SalarFusion',
    SAP: 'SAP',
    SCAB: 'SCAB',
    'SD Workx': 'SD Workx',
    'SDB*Salaris/SDB*HRM': 'SDB*Salaris/SDB*HRM',
    SDU: 'SDU',
    'Sdu Salaris Office': 'Sdu Salaris Office',
    'Thinq.nl': 'Thinq.nl',
    Ubplus: 'Ubplus',
    Unit4: 'Unit4',
    'Unit4 (lopac)': 'Unit4 (lopac)',
    VakWare: 'VakWare',
    'Visma DBS Talent & Salaris': 'Visma DBS Talent & Salaris',
    '(Win)Salar': '(Win)Salar',
};

export const SECTOR = {
    '1.1: Agrarisch bedrijf Premiegroep kort':
        '1.1: Agrarisch bedrijf Premiegroep kort',
    '1.2: Agrarisch bedrijf Premiegroep lang':
        '1.2: Agrarisch bedrijf Premiegroep lang',
    '2: Tabakverwerkende industrie': '2: Tabakverwerkende industrie',
    '3.1: Bouwbedrijf Premiegroep kort': '3.1: Bouwbedrijf Premiegroep kort',
    '3.2: Bouwbedrijf Premiegroep lang': '3.2: Bouwbedrijf Premiegroep lang',
    '4: Baggerbedrijf': '4: Baggerbedrijf',
    '5: Hout- en emballage-industrie, houtwaren- en borstelindustrie':
        '5: Hout- en emballage-industrie, houtwaren- en borstelindustrie',
    '6: Timmerindustrie': '6: Timmerindustrie',
    '7: Meubel- en orgelbouwindustrie': '7: Meubel- en orgelbouwindustrie',
    '8: Groothandel in hout, zagerijen, schaverijen en houtbereid.ind.':
        '8: Groothandel in hout, zagerijen, schaverijen en houtbereid.ind.',
    '9.1: Grafische industrie exclusief fotografen':
        '9.1: Grafische industrie exclusief fotografen',
    '9.2: Grafische industrie fotografen':
        '9.2: Grafische industrie fotografen',
    '10: Metaalindustrie': '10: Metaalindustrie',
    '11: Elektrotechnische industrie': '11: Elektrotechnische industrie',
    '12: Metaal- en technische bedrijfstakken':
        '12: Metaal- en technische bedrijfstakken',
    '13: Bakkerijen': '13: Bakkerijen',
    '14: Suikerverwerkende industrie': '14: Suikerverwerkende industrie',
    '15: Slagersbedrijven': '15: Slagersbedrijven',
    '16: Slagers overig': '16: Slagers overig',
    '17: Detailhandel': '17: Detailhandel',
    '18: Reiniging': '18: Reiniging',
    '19: Grootwinkelbedrijf': '19: Grootwinkelbedrijf',
    '20: Havenbedrijven': '20: Havenbedrijven',
    '21: Havenclassificeerders': '21: Havenclassificeerders',
    '22: Binnenscheepvaart': '22: Binnenscheepvaart',
    '23: Visserij': '23: Visserij',
    '24: Koopvaardij': '24: Koopvaardij',
    '25: Vervoer KLM': '25: Vervoer KLM',
    '26: Vervoer NS': '26: Vervoer NS',
    '27: Vervoer posterijen': '27: Vervoer posterijen',
    '28: Taxi- en ambulancevervoer': '28: Taxi- en ambulancevervoer',
    '29: Openbaar vervoer': '29: Openbaar vervoer',
    '30: Besloten busvervoer': '30: Besloten busvervoer',
    '31: Overig personenvervoer te land en in de lucht':
        '31: Overig personenvervoer te land en in de lucht',
    '32: Overig goederenvervoer te land en in de lucht':
        '32: Overig goederenvervoer te land en in de lucht',
    '33.1: Horeca algemeen Premiegroep kort':
        '33.1: Horeca algemeen Premiegroep kort',
    '33.2: Horeca algemeen Premiegroep lang':
        '33.2: Horeca algemeen Premiegroep lang',
    '34: Horeca catering': '34: Horeca catering',
    '35: Gezondheid, geestelijke en maatschappelijke belangen':
        '35: Gezondheid, geestelijke en maatschappelijke belangen',
    '38: Banken': '38: Banken',
    '39: Verzekeringswezen': '39: Verzekeringswezen',
    '40: Uitgeverij': '40: Uitgeverij',
    '41: Groothandel I': '41: Groothandel I',
    '42: Groothandel II': '42: Groothandel II',
    '43: Zakelijke dienstverlening I': '43: Zakelijke dienstverlening I',
    '44: Zakelijke dienstverlening II': '44: Zakelijke dienstverlening II',
    '45: Zakelijke dienstverlening III': '45: Zakelijke dienstverlening III',
    '46: Zuivelindustrie': '46: Zuivelindustrie',
    '47: Textielindustrie': '47: Textielindustrie',
    '48: Steen-, cement-, glas- en keramische industrie':
        '48: Steen-, cement-, glas- en keramische industrie',
    '49: Chemische industrie': '49: Chemische industrie',
    '50: Voedingsindustrie': '50: Voedingsindustrie',
    '51: Algemene industrie': '51: Algemene industrie',
    '52: Uitzendbedrijven': '52: Uitzendbedrijven',
    '52.1: - II A Premiegroep kortingsklasse':
        '52.1: - II A Premiegroep kortingsklasse',
    '52.2: - II A Premiegroep middenklasse':
        '52.2: - II A Premiegroep middenklasse',
    '52.3: - II A Premiegroep opslagklasse':
        '52.3: - II A Premiegroep opslagklasse',
    '52.4: - I A Premiegroep kortingsklasse':
        '52.4: - I A Premiegroep kortingsklasse',
    '52.5: - I A Premiegroep middenklasse':
        '52.5: - I A Premiegroep middenklasse',
    '52.6: - I A Premiegroep opslagklasse':
        '52.6: - I A Premiegroep opslagklasse',
    '52.7: - Premiegroep detachering': '52.7: - Premiegroep detachering',
    '52.8: - Premiegroep intermediaire diensten':
        '52.8: - Premiegroep intermediaire diensten',
    '52.9: Uitzendbedrijven I B + II B': '52.9: Uitzendbedrijven I B + II B',
    '53: Bewakingsondernemingen': '53: Bewakingsondernemingen',
    '54.1: Culturele instellingen Premiegroep kort':
        '54.1: Culturele instellingen Premiegroep kort',
    '54.2: Culturele instellingen Premiegroep lang':
        '54.2: Culturele instellingen Premiegroep lang',
    '55: Overige takken van bedrijf en beroep':
        '55: Overige takken van bedrijf en beroep',
    '56.1: Schildersbedrijf Premiegroep kort':
        '56.1: Schildersbedrijf Premiegroep kort',
    '56.2: Schildersbedrijf Premiegroep lang':
        '56.2: Schildersbedrijf Premiegroep lang',
    '57: Stukadoorsbedrijf': '57: Stukadoorsbedrijf',
    '58: Dakdekkersbedrijf': '58: Dakdekkersbedrijf',
    '59: Mortelbedrijf': '59: Mortelbedrijf',
    '60: Steenhouwersbedrijf': '60: Steenhouwersbedrijf',
    '61: Overheid, onderwijs en wetenschappen':
        '61: Overheid, onderwijs en wetenschappen',
    '62: Overheid, rijk, politie en rechterlijke macht':
        '62: Overheid, rijk, politie en rechterlijke macht',
    '63: Overheid, defensie': '63: Overheid, defensie',
    '64.1: Overheid, provincies, gemeenten en waterschappen':
        '64.1: Overheid, provincies, gemeenten en waterschappen',
    '64.2: Gemeenten, vervangende sectorpremie':
        '64.2: Gemeenten, vervangende sectorpremie',
    '65: Overheid, openbare nutsbedrijven':
        '65: Overheid, openbare nutsbedrijven',
    '66: Overheid, overige instellingen': '66: Overheid, overige instellingen',
    '67.1: Werk en (re)integratie': '67.1: Werk en (re)integratie',
    '67.2: Werk en (re)integratie, vervangende sectorpremie':
        '67.2: Werk en (re)integratie, vervangende sectorpremie',
    '68: Railbouw': '68: Railbouw',
    '69: Telecommunicatie': '69: Telecommunicatie',
};

export const LEGAL_FORM = {
    'Besloten Vennootschap (B.V.)': 'Besloten Vennootschap (B.V.)',
    'Commanditaire Vennootschap (C.V.)': 'Commanditaire Vennootschap (C.V.)',
    'Eenmanszaak (EZ)': 'Eenmanszaak (EZ)',
    'Vennootschaponder Firma (VOF)': 'Vennootschaponder Firma (VOF)',
    Stichting: 'Stichting',
    'Naamloze Vennootschap (N.V.)': 'Naamloze Vennootschap (N.V.)',
    vereniging: 'vereniging',
};

// Currently platform does not supports weekly and yearly reporting periods
export const REPORTING_PERIOD = {
    '4 weken': '4 weken',
    maand: 'maand',
    // 'jaar': 'jaar',
    // 'week': 'week',
};

export const FORM_STATUS = {
    'Geen status': 'Geen status',
    'Machtiging uitgevraagd bij werknemer':
        'Machtiging uitgevraagd bij werknemer (LKV)',
    'Machtiging uitgevraagd bij werknemer (dgr)':
        'Machtiging uitgevraagd bij werknemer (LKV - DGR)',
    'Machtiging uitgevraagd bij werknemer (Premiekorting - DGR)':
        'Machtiging uitgevraagd bij werknemer (Premiekorting - DGR)',
    'Verzoek ingediend bij UWV': 'Verzoek ingediend bij UWV',
    'Verzoek afgewezen bij UWV': 'Verzoek afgewezen bij UWV',
    'Doelgroepverklaring ontvangen': 'Doelgroepverklaring ontvangen',
    'Doelgroepenregister (premiekorting)':
        'Doelgroepenregister (premiekorting)',
    'Geen vervolgacties nodig': 'Geen vervolgacties nodig',
    'Verzoek ingediend bij gemeente': 'Verzoek ingediend bij gemeente',
    'Verzoek afgewezen bij gemeente': 'Verzoek afgewezen bij gemeente',
    'No response': 'No response',
    'No response bij positieve inventarisatie':
        'No response bij positieve inventarisatie',
    'Werknemer wil niet meewerken': 'Werknemer wil niet meewerken',
    'Werknemer wil niet meewerken (positieve reactie)':
        'Werknemer wil niet meewerken (positieve reactie)',
    'Geen telefoonnummer': 'Geen telefoonnummer',
};

export const FORM_STATUS_NUMERIC = {
    1: 'Geen status',
    2: 'Machtiging uitgevraagd bij werknemer (LKV)',
    3: 'Machtiging uitgevraagd bij werknemer (LKV - DGR)',
    5: 'Verzoek ingediend bij UWV',
    6: 'Verzoek afgewezen bij UWV',
    7: 'Doelgroepverklaring ontvangen',
    8: 'Doelgroepenregister (premiekorting)',
    9: 'Geen vervolgacties nodig',
    12: 'Verzoek ingediend bij gemeente',
    13: 'Verzoek afgewezen bij gemeente',
    14: 'No response',
    15: 'No response bij positieve inventarisatie',
    16: 'Werknemer wil niet meewerken',
    17: 'Werknemer wil niet meewerken (positieve reactie)',
    18: 'Geen telefoonnummer',
};

export const MACHTIGING_POINTS = {
    101: 'LKV ouderen',
    102: 'LKV arbeidsgehandicapte',
    103: 'LKV doelgroep banenafspraak',
    104: 'LKV herplaatst arbeidsgehandicapte',
    107: 'LKV buitenland ouderen',
    108: 'LKV buitenland arbeidsgehandicapte',
    201: 'PK oudere IOW',
    202: 'PK oudere Wajong',
    203: 'PK oudere Wamil',
    204: 'PK oudere WAO',
    205: 'PK oudere WAZ',
    206: 'PK oudere WIA',
    207: 'PK oudere WW',
    208: 'PK oudere FW',
    400: 'Belemmering bij werk',
    500: 'PK jongeren',
    601: 'PK ANW SVB Amstelveen',
    602: 'PK ANW SVB Breda',
    603: 'PK ANW SVB Deventer',
    604: 'PK ANW SVB Groningen',
    605: 'PK ANW SVB Leiden',
    606: 'PK ANW SVB Nijmegen',
    607: 'PK ANW SVB Roermond',
    608: 'PK ANW SVB Rotterdam',
    609: 'PK ANW SVB Utrecht',
    610: 'PK ANW SVB Zaanstad',
    701: 'PK Gemeente WWB',
    702: 'PK Gemeente IOAZ',
    703: 'PK Gemeente IOAW',
    704: 'PK Gemeente WIJ',
    705: 'PK Gemeente APPA',
    706: 'PK Gemeente WWIK',
    707: 'PK Gemeente Bbz',
};

export const MACHTIGING_POINTS_REACT = [
    { id: `machtiging-option-101`, value: 101, text: 'LKV ouderen' },
    {
        id: `machtiging-option-102`,
        value: 102,
        text: 'LKV arbeidsgehandicapte',
    },
    {
        id: `machtiging-option-103`,
        value: 103,
        text: 'LKV doelgroep banenafspraak',
    },
    {
        id: `machtiging-option-104`,
        value: 104,
        text: 'LKV herplaatst arbeidsgehandicapte',
    },
    { id: `machtiging-option-107`, value: 107, text: 'LKV buitenland ouderen' },
    {
        id: `machtiging-option-108`,
        value: 108,
        text: 'LKV buitenland arbeidsgehandicapte',
    },
    { id: `machtiging-option-201`, value: 201, text: 'PK oudere IOW' },
    { id: `machtiging-option-202`, value: 202, text: 'PK oudere Wajong' },
    { id: `machtiging-option-203`, value: 203, text: 'PK oudere Wamil' },
    { id: `machtiging-option-204`, value: 204, text: 'PK oudere WAO' },
    { id: `machtiging-option-205`, value: 205, text: 'PK oudere WAZ' },
    { id: `machtiging-option-206`, value: 206, text: 'PK oudere WIA' },
    { id: `machtiging-option-207`, value: 207, text: 'PK oudere WW' },
    { id: `machtiging-option-208`, value: 208, text: 'PK oudere FW' },
    { id: `machtiging-option-400`, value: 400, text: 'Belemmering bij werk' },
    { id: `machtiging-option-500`, value: 500, text: 'PK jongeren' },
    { id: `machtiging-option-601`, value: 601, text: 'PK ANW SVB Amstelveen' },
    { id: `machtiging-option-602`, value: 602, text: 'PK ANW SVB Breda' },
    { id: `machtiging-option-603`, value: 603, text: 'PK ANW SVB Deventer' },
    { id: `machtiging-option-604`, value: 604, text: 'PK ANW SVB Groningen' },
    { id: `machtiging-option-605`, value: 605, text: 'PK ANW SVB Leiden' },
    { id: `machtiging-option-606`, value: 606, text: 'PK ANW SVB Nijmegen' },
    { id: `machtiging-option-607`, value: 607, text: 'PK ANW SVB Roermond' },
    { id: `machtiging-option-608`, value: 608, text: 'PK ANW SVB Rotterdam' },
    { id: `machtiging-option-609`, value: 609, text: 'PK ANW SVB Utrecht' },
    { id: `machtiging-option-610`, value: 610, text: 'PK ANW SVB Zaanstad' },
    { id: `machtiging-option-701`, value: 701, text: 'PK Gemeente WWB' },
    { id: `machtiging-option-702`, value: 702, text: 'PK Gemeente IOAZ' },
    { id: `machtiging-option-703`, value: 703, text: 'PK Gemeente IOAW' },
    { id: `machtiging-option-704`, value: 704, text: 'PK Gemeente WIJ' },
    { id: `machtiging-option-705`, value: 705, text: 'PK Gemeente APPA' },
    { id: `machtiging-option-706`, value: 706, text: 'PK Gemeente WWIK' },
    { id: `machtiging-option-707`, value: 707, text: 'PK Gemeente Bbz' },
];

export const UITKERINGEN = {
    101: 'WW - Werkloosheidsuitkering',
    102: 'WAO, WIA WAZ ',
    103: 'Wajong, WSW, WIW, ID',
    104: 'WIA - Wet werk en inkomen naar arbeidsvermogen ',
    201: 'IOW - Wet inkomensvoorziening oudere werklozen',
    202: 'Wajong-uitkering',
    203: 'Wamil - Wet arbeidsongeschiktheidsvoorziening militairen',
    204: 'WAO - Wet op de arbeidsongeschiktheidsverzekering',
    205: 'WAZ -Wet arbeidsongeschiktheidsverzekering zelfstandigen',
    206: 'WIA - Wet werk en inkomen naar arbeidsvermogen ',
    207: 'WW - Werkloosheidsuitkering',
    208: 'FW - Failissements WW ',
    400: 'Wajong, WIA, WAO',
    500: 'WW of WWB - Wet werk en bijstand',
    601: 'ANW - Algemene nabestaande wet',
    602: 'ANW - Algemene nabestaande wet',
    603: 'ANW - Algemene nabestaande wet',
    604: 'ANW - Algemene nabestaande wet',
    605: 'ANW - Algemene nabestaande wet',
    606: 'ANW - Algemene nabestaande wet',
    607: 'ANW - Algemene nabestaande wet',
    608: 'ANW - Algemene nabestaande wet',
    609: 'ANW - Algemene nabestaande wet',
    610: 'ANW - Algemene nabestaande wet',
    701: 'WWB - Wet werk en bijstand',
    702: 'IOAZ - Wet Inkomensvoorziening Oudere en gedeeltelijke Arbeidsongeschikte  gewezen Zelfstandigen',
    703: 'IOAW - Wet Inkomensvoorziening Oudere en gedeeltelijke Arbeidsongeschikte werknemers',
    704: 'WIJ - Wet Investeren in Jongeren',
    705: 'APPA - Algemene Pensioenswet Politieke Ambtsdragers',
    706: 'WWIK - Wet werk en inkomen kunstenaars',
    707: 'Bbz - Bijstandsverlening zelfstandigen',
};

export const CustomerFormSections = [
    'Start',
    'Gegevensoverdracht',
    // 'No-risk polis',
    // 'Toegepaste premiekortingen',
    'Inventarisatie',
    'Escalatie',
    'Instroom',
    'Afronding',
    'Overige',
];

export const organisationOptions = [
    { key: 'o-01', value: 'Belastingdienst', text: 'Belastingdienst' },
    { key: 'o-02', value: 'Gemeente', text: 'Gemeente' },
    { key: 'o-03', value: 'SVB', text: 'SVB' },
    { key: 'o-04', value: 'UWV', text: 'UWV' },
];

export const ProgressOptionsDossier = [
    { key: 'empty', value: '', text: 'Geen' },
    { key: 'pr-1', value: 'Navraag klant', text: 'Navraag klant' },
    { key: 'pr-4', value: 'Ontbrekende stukken', text: 'Ontbrekende stukken' },
    { key: 'pr-7', value: 'Dossier ontvangen', text: 'Dossier ontvangen' },
];

export const looncodes = {
    11: 'Loon of salaris ambtenaren in de zin van de Ambtenarenwet',
    13: 'Loon of salaris directeuren van een nv of bv, wel verzekerd voor de werknemersverzekeringen',
    15: 'Loon of salaris niet onder te brengen onder 11, 13 of 17',
    17: 'Loon of salaris directeur-grootaandeelhouder van een nv of bv, niet verzekerd voor de werknemersverzekeringen',
    18: 'Wachtgeld van een overheidsinstelling',
    22: 'Uitkering in het kader van de Algemene Ouderdomswet (aow)',
    23: 'Oorlogs- en verzetspensioenen',
    24: 'Uitkering in het kader van de Algemene nabestaandenwet (Anw)',
    31: 'Uitkering in het kader van de Ziektewet (zw) en vrijwillige verzekering Ziektewet',
    32: 'Uitkering in het kader van de Wet op de arbeidsongeschiktheidsverzekering (wao) en particuliere verzekering ziekte, invaliditeit en ongeval',
    33: 'Uitkering in het kader van de Nieuwe Werkloosheidswet (nww)',
    34: 'Uitkering in het kader van de Wet inkomensvoorziening oudere en gedeeltelijk arbeidsongeschikte werkloze werknemers (ioaw)',
    35: 'Vervolguitkering in het kader van de Nieuwe Werkloosheidswet (nww)',
    36: 'Uitkering in het kader van de Wet arbeidsongeschiktheidsverzekering zelfstandigen (Waz)',
    37: 'Wet arbeidsongeschiktheidsvoorziening jonggehandicapten (Wajong)',
    38: 'Samenloop (gelijktijdig of volgtijdelijk) van uitkeringen van Wet Wajong met Waz, wao/iva of wga',
    39: 'Uitkering in het kader van de Regeling inkomensvoorziening volledig arbeidsongeschikten (iva)',
    40: 'Uitkering in het kader van de Regeling werkhervatting gedeeltelijk arbeidsgeschikten (wga)',
    42: 'Uitkering in het kader van bijstandsbesluit Zelfstandigen (Bbz)',
    43: 'Uitkering in het kader van de Participatiewet (voorheen Wwb)',
    45: 'Uitkering in het kader van de Wet inkomensvoorziening oudere en gedeeltelijk arbeidsongeschikte gewezen zelfstandigen (ioaz)',
    46: 'Uitkering uit hoofde van de Toeslagenwet',
    50: 'Uitkeringen in het kader van overige sociale verzekeringswetten; hieronder vallen ook de Ongevallenwet 1921, de Land- en tuinbouwongevallenwet 1922 en de Zeeongevallenwet 1919 (niet 22, 24, 31 tot en met 45 of 52)',
    52: 'Uitkering in het kader van de Wet inkomensvoorziening oudere werklozen (iow)',
    53: 'Uitkeringen in het kader van vervroegde uittreding',
    54: 'Opname levenslooptegoed door een werknemer die op 1 januari 61 jaar of ouder is',
    55: 'Uitkering in het kader van de Algemene Pensioenwet Politieke Ambtsdragers (APPA)',
    56: 'Ouderdomspensioen dat via de werkgever is opgebouwd',
    57: 'Nabestaandenpensioen dat via de werkgever is opgebouwd',
    58: 'Arbeidsongeschiktheidspensioen dat via de werkgever is opgebouwd',
    59: 'Lijfrenten die zijn afgesloten in het kader van een individuele of collectieve arbeidsovereenkomst',
    60: 'Lijfrenten die niet zijn afgesloten in het kader van een individuele of collectieve arbeidsovereenkomst',
    61: 'Aanvulling van de werkgever aan een werknemer op een uitkering werknemersverzekeringen, terwijl de dienstbetrekking is beëindigd',
    63: 'Overige, niet hiervoor aangegeven, pensioenen of samenloop van meerdere pensioenen/lijfrenten of een betaling op grond van een afspraak na einde dienstbetrekking',
};

export const aardcodes = {
    1: 'Arbeidsovereenkomst (exclusief BBL)',
    4: 'Deelvisser',
    6: 'Musicus/artiest',
    7: 'Stagiair',
    10: 'Wet sociale werkvoorziening (wsw)',
    11: 'Uitzendkracht',
    18: 'Publiekrechtelijke aanstelling',
    21: 'WSW beschut werk',
    22: 'WSW detachering bij reguliere werkgever',
    23: 'WSW begeleid werk',
    24: 'Participatiewet beschut werk',
    79: 'Opting-inregeling',
    81: 'Overige fictieve dienstbetrekkingen',
    82: 'Payrolling',
    83: 'Beroepspraktijko',
};

export const IMAGE_FILE_TYPE = 'image/*';
export const IMAGE_FILE_TYPE_PNGJPG = 'image/png, image/jpeg';
export const IMAGE_JPEG = 'image/jpeg';
export const PDF_FILE_TYPE = 'application/pdf';
export const EXCEL_FILE_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
export const CSV_FILE_TYPE = 'text/csv';
export const XML_FILE_TYPE = 'application/xml';
export const WORD_FILE_TYPE =
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword';

export const ACCEPT_FILE_TYPES = {
    pdf: 'application/pdf',
};
